import { render, staticRenderFns } from "./PublicApiAdder.vue?vue&type=template&id=467f14e7&"
import script from "./PublicApiAdder.vue?vue&type=script&lang=ts&"
export * from "./PublicApiAdder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports